import { AssetFieldsPopup } from './AssetFields';

export default AssetFieldsPopup;
